import React from 'react'
import MyProfile from './MyProfile'

const IndexMyProfile = () => {
  return (
    <>
      <MyProfile/>
    </>
  )
}

export default IndexMyProfile
